module.exports = __webpack_public_path__ + "img/daniel.1ffa280e.jpg";